import axios from "axios";
import { Config } from "../../data/config";

export const SET_SALES_REP = "BUILDING | SET_SALES_REP";
export const setSalesRep = payload => {
  return { type: SET_SALES_REP, payload };
};

export function getSalesRep(id)
{
  return function(dispatch) {
    axios
      .get(`${Config.frontApiUrl}/onboarding/salesrep/${id}`)
      .then(response => {
        dispatch(setSalesRep(response.data));
      });
  };
}


// WEBPACK FOOTER //
// ./src/store/actions/sales-rep.js